import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export function EnerleftMark({ size = 22 }) {
    return (
        <svg className="lp-logo-mark" width={size * 1.75} height={size} viewBox="0 0 44 24" aria-hidden="true">
            <rect x="0" y="2"  width="26" height="3.2" rx="1" fill="#F5F5F0" />
            <rect x="0" y="10" width="40" height="3.2" rx="1" fill="#E5FF00" />
            <rect x="0" y="18" width="18" height="3.2" rx="1" fill="#F5F5F0" />
        </svg>
    );
}

export default function Nav() {
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        // Nav sempre visibile; opzionalmente fade su scroll rapido — qui manteniamo sticky pieno
        const onScroll = () => setVisible(true);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    return (
        <nav
            className="lp-nav"
            aria-label="Navigazione principale"
            style={{ opacity: visible ? 1 : 0 }}
        >
            <span className="lp-nav-inner-left">
                <EnerleftMark />
                <span>
                    <span className="lp-logo-word">ENERLEFT</span>
                    <div className="lp-logo-tag">Full services</div>
                </span>
            </span>
            <span className="lp-nav-links">
                <a
                    className="lp-nav-link"
                    href="#contatti"
                    onClick={(e) => {
                        e.preventDefault();
                        const el = document.getElementById("contatti");
                        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                    }}
                    data-testid="nav-contatti"
                >
                    Contatti
                </a>
                <Link to="/login" className="lp-nav-link lp-nav-link-accent" data-testid="nav-accedi">
                    Accedi
                </Link>
            </span>
        </nav>
    );
}
